/* Timeline item — single career role entry. */
export const TimelineItem = ({ item, index }) => {
  return (
    <div
      data-testid={`timeline-${index}`}
      className="relative pb-12 md:pb-16 last:pb-0 reveal"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="absolute -left-[27px] md:-left-[43px] top-2 w-2.5 h-2.5 bg-[var(--ink)] rounded-full" />
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3">
          <div className="text-[10.5px] tracking-[0.22em] uppercase font-mono text-[var(--muted)]">
            {item.period}
          </div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
            {item.company}
          </div>
          <h3 className="text-2xl md:text-4xl font-bold tracking-tight mb-3 md:mb-4">
            {item.title}
          </h3>
          <p className="text-base md:text-lg text-[var(--muted)] leading-relaxed max-w-3xl">
            {item.summary}
          </p>

          {item.stats && (
            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 hairline border-l border-t max-w-3xl">
              {item.stats.map((s) => (
                <div key={s.k} className="hairline border-r border-b p-4">
                  <div className="text-[10px] tracking-[0.22em] uppercase opacity-50 mb-1.5">
                    {s.k}
                  </div>
                  <div className="font-mono text-xl md:text-2xl tracking-tight">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          )}

          {item.highlights && (
            <ul className="mt-5 space-y-1.5 max-w-2xl">
              {item.highlights.map((h) => (
                <li
                  key={h}
                  className="text-sm md:text-base text-[var(--ink)] flex gap-3"
                >
                  <span className="opacity-40">—</span>
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
